import { defineAsyncComponent } from 'vue'
export default {
  clean: defineAsyncComponent(() => import("/app/layouts/clean.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  management: defineAsyncComponent(() => import("/app/layouts/management.vue").then(m => m.default || m)),
  printers: defineAsyncComponent(() => import("/app/layouts/printers.vue").then(m => m.default || m))
}